/** Key names for values stored via `SessionStorageManager`, the session-scoped sibling of `StorageManager.KEYS`. */
export const sessionStorageKeys = {
  AGENT_OUTPUT_EXPLANATION_PROTIP_DISMISSED: "agent-output-explanation-protip-dismissed",
  NRO_404_RELOAD_MARKER: "nro-404-reload-marker",
  DUST_UNREACHABLE_IN_TAB: "dust-unreachable-in-tab",
} as const;

/** One of the `sessionStorageKeys` values — the only keys `SessionStorageManager` accepts. */
export type SessionStorageKey = (typeof sessionStorageKeys)[keyof typeof sessionStorageKeys];

/** Probe key written and immediately removed by the `SessionStorageManager` support check; not a `SessionStorageKey`. */
export const supportProbeKey = "test";
